// ABOUTME: The node readonly state as the UI consumes it, mirroring the GraphQL NodeReadonlyState.
// ABOUTME: NOT_LOCKED is the default of the context, so a node without a rule is always writable.

export type NodeReadonlyState = {
    locked: boolean;
    excludedFields: string[];
    message?: string | null;
    error?: string | null;
};

export const NOT_LOCKED: NodeReadonlyState = { locked: false, excludedFields: [] };
